import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const lendingApi = {
  getPool(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_POOL, {query});
  },
  getPublicPool(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_PUBLIC_DATA_POOL, {query});
  },
  getAssets(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_ASSETS_OVERVIEW, {query});
  },
  getSupportCurrencies() {
    return http.get(API_URLS.LENDING_SUPPORT_CURRENCIES, {});
  },
  getHistCollateral(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_HIST_COLLATERAL, {query});
  },
  getHistLiq(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_HIST_LIQ, {query});
  },
  getHistLoan(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_HIST_LOAN, {query});
  },
  getHistPayback(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_HIST_PAYBACK, {query});
  },
  getHistInterest(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_HIST_INTEREST, {query});
  },
  getHisFunds(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_HIST_FUNDS, {query});
  },
  getLoanActiveOrders(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_LOAN_ACTIVE, {query});
  },
  getLoanQuota(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_LOAN_QUOTA, {query});
  },
  getPublicDataApr(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_PUBLIC_DATA_APR, {query});
  },
  postLoan(params) {
    return http.post(API_URLS.LENDING_LOAN, {params});
  },
  postInternalPoolConfig(params) {
    return http.post(API_URLS.LENDING_INTERNAL_POOL_CONFIG, {params});
  },
  postInternalPoolConfigDb(params) {
    return http.post(API_URLS.LENDING_INTERNAL_POOL_CONFIG_DB, {params});
  },
  postLoanAddCollateral(params) {
    return http.post(API_URLS.LENDING_LOAN_ADD_COLLATERAL, {params});
  },
  postPayback(params) {
    return http.post(API_URLS.LENDING_PAYBACK, {params});
  },
  postAccountsOpen() {
    return http.post(API_URLS.LENDING_ACCOUNTS_OPEN, {});
  },
  postSupply(params) {
    return http.post(API_URLS.LENDING_SUPPLY, {params});
  },
  postRedeem(params) {
    return http.post(API_URLS.LENDING_REDEEM, {params});
  },
  postAutoInvest(params) {
    return http.post(API_URLS.LENDING_AUTO_INVEST, {params});
  },
  getSupplyAccounts(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_ASSETS_ACCOUNT_SUPPLY, {query});
  },
  getSupplyActive(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_SUPPLY_ACTIVE, {query});
  },
  getHistSupply(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_HIST_SUPPLY, {query});
  },
  getHistSupplyRedemption(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_HIST_SUPPLY_REDEMPTION, {query});
  },
  getHistSupplyInterest(query?: Record<string, any>) {
    return http.get(API_URLS.LENDING_HIST_SUPPLY_INTEREST, {query});
  },
};
